/**
 * The query parameters used by UNO Web
 */ export var WebQueryParams = /*#__PURE__*/ function(WebQueryParams) {
    /** Called after logout */ WebQueryParams["Logout"] = "logout";
    /** AAD User ID */ WebQueryParams["UserId"] = "userObjectId";
    /** AAD UPN (UserPrincipalName) */ WebQueryParams["Upn"] = "auth_upn";
    /** Tenant ID */ WebQueryParams["TenantId"] = "tid";
    /** Locale Override */ WebQueryParams["Mkt"] = "mkt";
    /** Query param from a ocdi redirect */ WebQueryParams["OcdiRedirect"] = "ocdiRedir";
    /** Query param from a ocdi timestamp as unix time in seconds */ WebQueryParams["OcdiTimestamp"] = "ocdiTs";
    /** Query param from a ocdi guid */ WebQueryParams["OcdiGuid"] = "ocdiId";
    /** Web redirect indication parameter */ WebQueryParams["UnowebRedirect"] = "unowebRedir";
    /** Query param to indicate no prompt should be shown */ WebQueryParams["NoPrompt"] = "noPrompt";
    /** Query param to route request to correct planner service region */ WebQueryParams["PlannerRouteHint"] = "PlannerRouteHint";
    /**  Query param used to indicate whether ECS check (server side) for enabling Planner service UI host has been checked or not **/ WebQueryParams["EnableRedirectToPlannerUIHost"] = "EnablePlannerServiceWebuiEntry";
    return WebQueryParams;
}({});
/**
 * The URL segments used by UNO Web
 */ export var WebUrlSegments = /*#__PURE__*/ function(WebUrlSegments) {
    /** Web UI prefix (legacy) */ WebUrlSegments["WebUI"] = "webui";
    /** Planner Service Web UI prefix (new) */ WebUrlSegments["PlannerServiceWebPathSegment"] = "ui/web";
    /** Gcc specific sub route path */ WebUrlSegments["GccPath"] = "gcc";
    /** Blank msal redirect path */ WebUrlSegments["BlankMsalRedirect"] = "blankmsalredirect";
    /** Redirect bridge path for MSAL */ WebUrlSegments["RedirectBridge"] = "redirectbridge";
    /** Redirect bridge2 path for MSAL */ WebUrlSegments["RedirectBridge2"] = "redirectbridge2";
    return WebUrlSegments;
}({});
/**
 * Names of events used in web
 */ export var WebAuthEventNames = /*#__PURE__*/ function(WebAuthEventNames) {
    WebAuthEventNames["SuiteNavLogoutEventName"] = "suiteNavLogout";
    return WebAuthEventNames;
}({});
/** The value of query parameter logout on success */ export const LogoutSuccessfulQueryParamValue = "1";
